import React, { useContext, useEffect, useState } from "react";
import OptionsBox from "@ui/options-box";
import PageActionContext from "@stores/page-action-context";
import StandardInput from "@ui/inputs/standard-input";
import useInput from "@ui/inputs/use-input";
import AppDataContext from "@stores/app-data-context";

const FormLoanType = ({ data }) => {
    const {
        loanTypeOptionsBox,
        abnRegisteredOptionsBox,
        businessRegisteredForGstOptionsBox,
        noOfYearsBusinessOperating,
    } = data;

    const appDataCxt = useContext(AppDataContext);
    const pageActionCxt = useContext(PageActionContext);

    const noOfYearsBusinessOperatingInput = useInput(
        noOfYearsBusinessOperating
    );

    const [loanType, setloanType] = useState(null);
    const [abnRegistered, setAbnRegistered] = useState(null);
    const [businessRegisteredForGst, setbusinessRegisteredForGst] =
        useState(null);

    const [loanTypeOption, setLoanTypeOption] = useState(null);

    const loadFromContext = () => {
        const data = appDataCxt.getLoanType();
        if (data) {
            if (data.loanType) {
                loanTypeOptionsBox.value = data.loanType;
            }
            if (data.abnRegistered) {
                abnRegisteredOptionsBox.value = data.abnRegistered;
            }
            if (data.businessRegisteredForGst) {
                businessRegisteredForGstOptionsBox.value =
                    data.businessRegisteredForGst;
            }
            if (data.noOfYearsBusinessOperating)
                noOfYearsBusinessOperatingInput.initValue(
                    data.noOfYearsBusinessOperating
                );
        }
    };

    useEffect(() => {
        pageActionCxt.reset();
        loadFromContext();
    }, []);

    const handleLoanTypeOptionSelected = (opt) => {
        if (opt === null) return;
        setloanType(opt.value);
        setLoanTypeOption(opt);
    };
    const handleBusinessRegisteredForGstOptionSelected = (opt) => {
        setbusinessRegisteredForGst(opt.value);
    };
    const handleAbnRegisteredOptionSelected = (opt) => {
        setAbnRegistered(opt.value);
    };
    const isFormValid = () => {
        return (
            loanType === "personal" ||
            (loanType === "business" &&
                noOfYearsBusinessOperatingInput.isValidState() &&
                abnRegistered &&
                businessRegisteredForGst)
        );
    };
    useEffect(() => {
        pageActionCxt.setNextDisabled(!isFormValid());
    }, [
        loanType,
        abnRegistered,
        businessRegisteredForGst,
        noOfYearsBusinessOperatingInput,
        noOfYearsBusinessOperatingInput.isValidState(),
    ]);

    useEffect(() => {
        if (pageActionCxt.isNextClicked) {
            handleNextClicked();
        }
    }, [pageActionCxt.isNextClicked]);

    const handleNextClicked = () => {
        if (!loanTypeOption) return;
        const loanTypeData = {
            loanType: loanType,
            abnRegistered: abnRegistered,
            businessRegisteredForGst: businessRegisteredForGst,
            noOfYearsBusinessOperating:
                parseInt(noOfYearsBusinessOperatingInput.value, 10) ?? null,
        };
        appDataCxt.setLoanType(loanTypeData);
        const nextUrl = loanTypeOption.data.nextUrl;
        if (nextUrl) {
            pageActionCxt.setNextDisabled(false);
            pageActionCxt.navigate(nextUrl.url, nextUrl.isExternal);
        }
    };

    return (
        <>
            <div className="mb-8">
                <OptionsBox
                    data={loanTypeOptionsBox}
                    onOptionSelected={handleLoanTypeOptionSelected}
                />
            </div>
            {loanType === "business" && (
                <>
                    <div className="mb-8">
                        <OptionsBox
                            data={abnRegisteredOptionsBox}
                            onOptionSelected={handleAbnRegisteredOptionSelected}
                        />
                    </div>
                    <div className="mb-8">
                        <OptionsBox
                            data={businessRegisteredForGstOptionsBox}
                            onOptionSelected={
                                handleBusinessRegisteredForGstOptionSelected
                            }
                        />
                    </div>
                    <div className="mt-8">
                        <StandardInput
                            {...noOfYearsBusinessOperating}
                            {...noOfYearsBusinessOperatingInput}
                        />
                    </div>
                </>
            )}
        </>
    );
};
export default FormLoanType;
